module.exports = require("././angular.js");


/*****************
 ** WEBPACK FOOTER
 ** angular (bower component)
 ** module id = 4
 ** module chunks = 0
 **/